import Api from '@/services/api.js';
import vSelect from 'vue-select'

export default {
	components: {
		vSelect
	},

	computed: {},

	watch: {},

	data() {
		return {
			items: [],
			strOrdem: '',
			limiteClientes: [10, 25, 50, 100, 1000],
			limiteSelecionado: 10,
			blPesquisando: false,
			formFilter: {
				id: '',
				cliente: '',
				usuario: '',
				pro: false
			},
			paginate: ['items']
		}
	},

	methods: {
		filtrarItems() {
			this.items = [];
			let postData = {
				id_cadastro: this.formFilter.id,
				nome_cadastro: this.formFilter.cliente,
				codigo_cadastro: this.formFilter.usuario
			}
			this.blPesquisando = true;
			let url = (this.formFilter.pro ? 'Usuario/listarUsuariosPro' : 'Usuario/listarUsuariosSimularAcesso');

			new Api()
				.post(url, postData)
				.then(response => {
					this.items = response.dados;
				})
				.finally(() => {
					this.blPesquisando = false;
					if (this.$refs.paginator) {
						this.$refs.paginator.goToPage(1)
					}
				});
		},

		simularAcesso(cliente, status, token) {
			if (status == true) {
				this.$bus.$emit('simularAcesso', [status, cliente, this.formFilter.pro, token]);
			}
		},

		changePro() {
			this.items = [];
		}
	}
}